"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cotopaxi_1 = require("@as/cotopaxi");
exports.default = () => cotopaxi_1.cotopaxiVersion;
